import {combineReducers} from 'redux'
import {createPivotTableReducer} from 'reducers/pivotTable'
import Immutable from 'seamless-immutable'
import {createNewItem} from 'reducers/purchasingContext/selected'

export const purchaseOrderReceiveItemsDialogPivotTableKey = 'dialogs.purchaseOrderReceiveItems.purchaseOrderItems'

export default combineReducers({
    purchaseOrderItems: createPivotTableReducer({
        key: purchaseOrderReceiveItemsDialogPivotTableKey,
        defaultSortColumn: 'itemId',
        defaultSortDirection: Immutable('asc'),
        pageSize: 50,
        defaultGridStretch: false,
        defaultAreAllRowsSelected: false,
        defaultCanSelectRows: false,
        retainEdits: false,
        onNewEntity: createNewItem,
    }),
})

